/**
 * LD countdown — shared by sections/ld-countdown-bar.liquid and
 * sections/ld-cta-banner.liquid.
 *
 * Any element with [data-ld-end="<ISO date>"] containing a child with
 * [data-ld-clock] is picked up independently, so multiple countdowns
 * on the same page (top bar + mid-page CTA) each run on their own.
 *
 * Optional [data-ld-final-threshold="<hours>"] on the same element
 * toggles an `is-final-hours` class once that many hours remain, and
 * `is-ended` once the countdown reaches zero.
 *
 * Safe to load more than once on the same page: both sections above
 * each output their own <script src="ld-countdown.js">, so when a
 * page uses more than one of them the file is included — and its
 * top-level code runs — multiple times. Every container is marked
 * with [data-ld-initialized] the moment its tick loop starts, and
 * later runs skip anything already marked, so clocks never end up
 * with several competing timers stepping on the same text (which
 * looked like the countdown flickering/jumping).
 */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function tick(container, clock) {
    var end = new Date(container.getAttribute('data-ld-end')).getTime();
    if (isNaN(end)) return;

    var thresholdHours = parseFloat(container.getAttribute('data-ld-final-threshold') || '48');
    var ms = end - Date.now();

    if (ms <= 0) {
      container.classList.add('is-ended');
      clock.textContent = '00d 00h 00m';
      return;
    }

    var isFinal = ms < thresholdHours * 3600000;
    container.classList.toggle('is-final-hours', isFinal);

    var d = Math.floor(ms / 86400000);
    var h = Math.floor((ms % 86400000) / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var s = Math.floor((ms % 60000) / 1000);

    clock.textContent = isFinal
      ? pad(Math.floor(ms / 3600000)) + 'h ' + pad(m) + 'm ' + pad(s) + 's'
      : d + 'd ' + pad(h) + 'h ' + pad(m) + 'm';

    setTimeout(function () {
      tick(container, clock);
    }, isFinal ? 1000 : 30000);
  }

  function init() {
    document.querySelectorAll('[data-ld-end]').forEach(function (container) {
      if (container.hasAttribute('data-ld-initialized')) return;

      var clock = container.querySelector('[data-ld-clock]');
      if (!clock) return;

      container.setAttribute('data-ld-initialized', '');
      tick(container, clock);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
